import mutations from './mutations'

import { loadItemsBuilder, loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'measurementUnits'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint })
  },

  mutations: {
    ...mutations
  }
}
